// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"806":"user","933":"auth"}[chunkId] || chunkId) + "." + {"653":"b145c14e","806":"d8cefd01","933":"24367eba","989":"2031e265"}[chunkId] + ".js";
};